import Immutable from 'seamless-immutable';
import { FETCH_PRODUCT_SERVICE_RELATIONSHIPS } from './actions/product.service.relationships.actions';
import { EMPTY_ARRAY } from './constants/common.constants';
export var INITIAL_STATE = Immutable({
  data: EMPTY_ARRAY,
  isFetching: false,
  retrieveError: null
});
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case FETCH_PRODUCT_SERVICE_RELATIONSHIPS.BEGIN:
      return state.set('isFetching', true);
    case FETCH_PRODUCT_SERVICE_RELATIONSHIPS.SUCCESS:
      return state.set('isFetching', false).set('data', payload.ConsumerPlans).set('retrieveError', null);
    case FETCH_PRODUCT_SERVICE_RELATIONSHIPS.FAILURE:
      return state.set('isFetching', false).set('retrieveError', {
        code: payload.Code,
        message: payload.translatedMessage,
        severity: payload.Severity
      });
    default:
      return state;
  }
});